import Image from "next/image";
import { ModuleColumn } from "@/components/module";

import imgPortfolio from "@/img/product/portfolio_builder.png";

export default function PortfolioBuilderModule() {
  return (
    <ModuleColumn
      graphic={
        <Image
          src={imgPortfolio}
          alt="Illustration of a carbon removal portfolio on top of growing plants"
          placeholder="blur"
          draggable={false}
        />
      }
      headline="Fund a portfolio"
      className="module-portfolio-builder"
    >
      <p>
        Build a custom portfolio of bets, mixing long-term investments in
        cutting-edge projects with quick emissions reductions. Design your
        portfolio and track your impact in the dashboard; we’ll handle the
        paperwork.
      </p>
      <style jsx global>{`
        section.module-portfolio-builder {
          background-color: hsl(68deg 49% 91%);
          justify-content: space-between;
        }
        section.module-portfolio-builder .padded-box {
          background-image: linear-gradient(
            hsl(68deg 69% 96%),
            hsl(68deg 49% 91%)
          );
          padding-bottom: 0 !important;
        }
        .module-portfolio-builder h3 {
          color: hsl(70, 4%, 24%);
        }
        .module-portfolio-builder p {
          color: hsl(70, 9%, 34%);
          padding-bottom: 18px;
          margin-bottom: auto !important;
        }
      `}</style>
    </ModuleColumn>
  );
}
